export default {"src":"https://assets.ctr1.net/d1a32bdc1f09/_next/static/media/c1-on-c1.cdc54079.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};